<script setup lang="ts">
import HeaderNumber from '~/components/pages/home/NewComponents/HeaderNumber.vue'

defineOptions({
	name: 'HeaderNumbers',
})

const props = defineProps({
	blockNumbers: {
		type: Object,
		required: true,
	},
	rules: {
		type: Object,
		required: true,
	},
	shouldShowNumber: {
		type: Function,
		default: () => ({}),
	},
	visibleFirstCount: {
		type: Number,
		default: 0,
	},
	visibleLastCount: {
		type: Number,
		default: 0,
	},
	classContainerNumbers: {
		type: String,
		default: '',
	},
	showClassAnimation: {
		type: Boolean,
		default: true,
	},
})

const { t: $t } = useI18n()

const emit = defineEmits(['clearNumber', 'clearAll', 'shouldShowNumber'])

const showBtnClear = computed(() => {
	const first = props.blockNumbers.first.some((num: number) => num !== null)
	const last = props.blockNumbers.last ? props.blockNumbers.last.some((num: number) => num !== null) : false
	return first || last
})

const clearNumber = (property: string, index: number) => {
	emit('clearNumber', { property, index })
}

const clearAll = () => {
	emit('clearAll')
}
</script>

<template>
	<div>
		<div
			class="headerBalls relative"
			:class="[props.classContainerNumbers, { 'gap-5 sm:gap-10': blockNumbers.last && blockNumbers.last.length > 0 }]"
		>
			<!-- Bloque Principal -->
			<div
				class="flex justify-center items-center gap-3.5"
				:class="{ 'flex-wrap': !(blockNumbers.last && blockNumbers.last.length > 0), firstBalls: showClassAnimation }"
			>
				<Transition
					v-for="(number, index) in blockNumbers.first"
					:key="`first-header-${index}`"
					name="bounce"
				>
					<HeaderNumber
						:value="shouldShowNumber(index, 'first') ? number : null"
						:is-empty="index >= visibleFirstCount"
						@clear="clearNumber('first', index)"
					/>
				</Transition>
			</div>

			<!-- Bloque Bonus -->
			<div
				class="flex justify-center items-center gap-3.5"
				:class="{ lastBalls: showClassAnimation }"
				v-if="props.rules.last_block"
			>
				<Transition
					name="bounce"
					v-for="(number, index) in blockNumbers.last"
					:key="`last-header-${index}`"
				>
					<HeaderNumber
						:value="shouldShowNumber(index, 'last') ? number : null"
						:isEmpty="index >= visibleLastCount"
						:isYellowBall="true"
						@clear="clearNumber('last', index)"
					/>
				</Transition>
			</div>
			<UButton
				v-if="showBtnClear"
				variant="link"
				:label="$t('Clear all')"
				class="text-white text-base hover:text-white hover:no-underline px-3 py-1.5 rounded hover:bg-white/[0.1] transition-all duration-300 absolute -right-32 hidden md:flex"
				@click="clearAll()"
			/>
		</div>
		<UButton
			v-if="showBtnClear"
			variant="link"
			:label="$t('Clear all')"
			class="text-white text-base hover:text-white hover:no-underline px-3 py-1.5 rounded hover:bg-white/[0.1] transition-all duration-300 md:hidden sm:ml-10"
			@click="clearAll()"
		/>
	</div>
</template>
